<template>
  <div class="quality-page">
    <!-- 列表视图 -->
    <div class="main-area" v-show="showPart === '1'">
      <!-- 左侧可折叠组织树 -->
      <CollapsibleTree :visible="leftTreeVisible" @toggle="leftTreeVisible = !leftTreeVisible" @node-click="handleNodeClick" />

      <!-- 右侧内容区 -->
      <div class="content-card" :class="{ 'full-width': !leftTreeVisible }">
        <!-- 筛选栏 -->
        <div class="filter-bar">
          <div class="filter-row">
            <div class="choose1">
              <el-select v-model="choose1" style="width: 150px;" @change="changeTips">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-input style="width: 200px;" v-model="changeParm" :placeholder="nowTips" clearable />
            </div>
            <span class="sp-search" @click="getTableData()">
              <span><img src="@/assets/station/fdj.webp" alt=""></span>
              <span>查询</span>
            </span>
            <div class="choose2">
              <el-select v-model="choose2" style="width: 150px;" @change="changeTips2">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-select v-model="riskValue" v-show="nowTips2 === '隐患类型'" style="width:200px;" placeholder="选择隐患类型">
                <el-option v-for="item in riskType" :label="item.alertLevelName" :value="item.alertLevel" :key="item.id" />
              </el-select>
              <el-select v-model="riskValue" v-show="nowTips2 === '隐患等级'" style="width:200px;" placeholder="选择隐患等级">
                <el-option v-for="item in riskList" :key="item.riskLevel" :label="item.riskLevelName" :value="item.riskLevel" />
              </el-select>
            </div>
            <el-button @click="refresh">重置</el-button>
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="eleList">
          <div class="grid-container">
            <listDetail v-for="(item, index) in tableData" :key="index" :data="item" @detail-click="toDetail" ref="listDetail" />
          </div>
        </div>

        <!-- 分页 -->
        <div class="elePage">
          <el-pagination
            @current-change="pageChange"
            @size-change="handleSizeChange"
            background
            :current-page="currentPage"
            :page-sizes="[12,16,20,24,30,36]"
            :page-size="pageSize"
            layout="total,sizes,prev, pager, next, jumper"
            :total="paginationTotal" />
        </div>
      </div>
    </div>

    <!-- 详情视图 -->
    <div class="detail-area" v-show="showPart === '2'">
      <div class="detail-header">
        <span class="detail-title">电能质量 / {{ detailDeptName }}</span>
        <el-button @click="backList">返回</el-button>
      </div>
      <div class="detail-body">
        <div class="Harmonic">
          <ele-detail-box ele-detail-title="谐波数据">
            <template v-slot:detailMore>
              <div class="harmonicMore">
                <div class="bor-btn" :class="isdl === index? 'active-btn' : ''" v-for="(item,index) in detailTopList" :key="index" @click="changed(index,item)">
                  {{ item.description }}
                </div>
                <el-date-picker v-model="xbDate" value-format="yyyy-MM-dd" placeholder="查询时间" type="date" />
              </div>
            </template>
            <template v-slot:detailContent>
              <div class="cav-wrapper">
                <div class="cavItem" id="leftcav" />
                <div v-show="loadingCav" class="cav-loading"><div class="cav-spinner"/></div>
                <div v-show="noDataCav" class="cav-empty"><span>暂无数据</span></div>
              </div>
            </template>
          </ele-detail-box>
        </div>
        <div class="elePower">
          <ele-detail-box ele-detail-title="电能质量分析">
            <template v-slot:detailContent>
              <div class="power">
                <div class="powerItem">
                  <ele-power-box ele-power-title="谐波含量">
                    <template v-slot:time>
                      <el-date-picker v-model="xbhlDate" value-format="yyyy-MM-dd" type="date" />
                    </template>
                    <template v-slot:main>
                      <div class="cav-wrapper">
                        <div class="cavItem" id="leftcav01" />
                        <div v-show="loadingCav01" class="cav-loading"><div class="cav-spinner"/></div>
                        <div v-show="noDataCav01" class="cav-empty"><span>暂无数据</span></div>
                      </div>
                    </template>
                  </ele-power-box>
                </div>
                <div class="powerItem">
                  <ele-power-box ele-power-title="电压偏差">
                    <template v-slot:time>
                      <el-date-picker v-model="dypcDate" value-format="yyyy-MM-dd" type="date" />
                    </template>
                    <template v-slot:main>
                      <div class="cav-wrapper">
                        <div class="cavItem" id="leftcav02" />
                        <div v-show="loadingCav02" class="cav-loading"><div class="cav-spinner"/></div>
                        <div v-show="noDataCav02" class="cav-empty"><span>暂无数据</span></div>
                      </div>
                    </template>
                  </ele-power-box>
                </div>
                <div class="powerItem">
                  <ele-power-box ele-power-title="频率偏差">
                    <template v-slot:time>
                      <el-date-picker v-model="plpcDate" value-format="yyyy-MM-dd" type="date" />
                    </template>
                    <template v-slot:main>
                      <div class="cav-wrapper">
                        <div class="cavItem" id="leftcav03" />
                        <div v-show="loadingCav03" class="cav-loading"><div class="cav-spinner"/></div>
                        <div v-show="noDataCav03" class="cav-empty"><span>暂无数据</span></div>
                      </div>
                    </template>
                  </ele-power-box>
                </div>
              </div>
            </template>
          </ele-detail-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "utils/Axios";
import Axios2 from "utils/Axios2";
import CollapsibleTree from "components/CollapsibleTree.vue"
import listDetail from "pages/stationManagePage/components/listDetail.vue";
import EleDetailBox from "@/components/h5/eleDetailBox.vue";
import qs from "qs";
import ElePowerBox from "@/components/h5/elePowerBox.vue";

export default{
  components: {ElePowerBox, EleDetailBox, listDetail, CollapsibleTree },
  mounted() {
    this.deptId=localStorage.getItem('deptId');
    this.getNowTime();
    this.getRiskLev();
    this.getRiskList();
    this.getTableData();
  },
  computed:{
    computedTitle(){
      return "电能质量/" + this.detailDeptName
    }
  },
  data() {
    return {
      leftTreeVisible: true,
      showPart: '1',
      deptId: '',
      choose1: '1',
      options: [
        { value: '1', label: '监测点名称'},
        { value: '2', label: '设备imei'},
      ],
      choose2:'1',
      options2:[
        { value: '1', label: '隐患类型' },
        { value: '2', label: '隐患等级' },
      ],
      nowTips: '请输入监测点名称',
      nowTips2: '隐患类型',
      changeParm: '',
      imei: '',
      siteName: '',
      alertLevel: '',
      riskLevel: '',
      riskValue: '',
      riskType: [],
      riskList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 12,
      paginationTotal: 0,
      detailBranchId: '',
      detailSaveId: '',
      detailDeptName: '',
      detailTopList: [],
      isdl: 0,
      dldata: '',
      xbDate: '',
      xbhlDate: '',
      dypcDate: '',
      plpcDate: '',
      noDataCav: true,
      noDataCav01: true,
      noDataCav02: true,
      noDataCav03: true,
      loadingCav: false,
      loadingCav01: false,
      loadingCav02: false,
      loadingCav03: false,
    }
  },
  methods: {
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var date = now.getDate();
      var lastmonth=now.getMonth()
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if(lastmonth==0){ lastmonth=12 }
      if (lastmonth < 10) lastmonth = "0" + lastmonth;
      var time = year + "-" + month + "-" + date ;
      this.xbDate=time
      this.xbhlDate=time
      this.dypcDate=time
      this.plpcDate=time
    },
    handleNodeClick(data) {
      this.deptId = data.deptId;
      this.getTableData();
    },
    changeTips(){
      if(this.choose1 === '1'){
        this.nowTips = "请输入监测点名称"
      }else{
        this.nowTips = "请输入设备imei"
      }
      this.changeParm = null
    },
    changeTips2(){
      if(this.choose2 === '1'){
        this.nowTips2 = "隐患类型"
      }else{
        this.nowTips2 = "隐患等级"
      }
      this.riskValue = null
    },
    getRiskLev(){
      let param = {};
      param.method="post";
      param.url="/alert/getRiskLevels";
      Axios.ajax(param).then((res)=>{
        if (res.resultCode == 0) {
          this.riskList=res.data
          this.riskList.unshift({ riskLevel: null, riskLevelName: "全部" })
        } else {
          this.$message.warning(res.resultMessage);
        }
      })
    },
    getRiskList(){
      let param = {};
      param.method="post";
      param.url="/risk/getAlertLevels";
      Axios.ajax(param).then((res)=>{
        if(res.data){
          this.riskType=res.data
          this.riskType.unshift(
            { alertLevel: '-2', alertLevelName: "有隐患" },
            { alertLevel: '-1', alertLevelName: "未绑定" },
            { alertLevel: null, alertLevelName: "全部" },
          )
        }
      })
    },
    refresh() {
      this.riskType = null
      this.changeParm = null
      this.riskValue = null
      this.getTableData()
    },
    backList(){
      this.detailBranchId = '';
      this.detailSaveId = '';
      this.showPart = '1';
    },
    getTableData(){
      if(this.choose1 === '1'){
        this.siteName = this.changeParm
      }else{
        this.imei = this.changeParm
      }
      if(this.choose2 === '1'){
        this.alertLevel = this.riskValue
      }else{
        this.riskLevel = this.riskValue
      }
      let param = {};
      param.method="get";
      param.url="api/v3/monitor/queryList";
      param.params={
        "pageNum": this.currentPage,
        "showNum": this.pageSize,
        "deptId": this.deptId,
        "imei": this.imei,
        "siteName": this.siteName,
        "alertLevel": this.alertLevel,
        "riskLevel": this.riskLevel,
        "groupId": this.itemType,
      }
      Axios2.ajax(param).then((res)=>{
        if(res.data){
          this.tableData = res.data.dataList
          this.paginationTotal = res.data.totalNum
        }
      })
    },
    pageChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    handleSizeChange(val){
      this.pageSize=val
      this.getTableData()
    },
    toDetail(item){
      this.showPart = '2';
      this.detailBranchId = item.branchId;
      this.detailSaveId = item.id;
      this.noDataCav = this.noDataCav01 = this.noDataCav02 = this.noDataCav03 = true;
      this.loadingCav = this.loadingCav01 = this.loadingCav02 = this.loadingCav03 = true;
      this.getDetail(item.id);
      this.getDetailTop(item.id);
      this.getxbhldata()
      this.getdypcdata()
      this.getplpcdata()
    },
    getDetail(id){
      let param = {};
      param.method="post";
      param.url = "/monitor/getMonitorSiteInfo";
      param.params = { monitorSiteId: id }
      Axios.ajax(param).then(res => {
        if(!res.data) return
        this.detailDeptName = res.data.deptName;
      })
    },
    getDetailTop(id){
      let param = {};
      param.method="post";
      param.url = "/electricQuality/getHarmonicParam";
      param.params = { monitorSiteId: id, type: 'Param' }
      Axios.ajax(param).then(res => {
        if(!res.data || !res.data.length) {
          this.loadingCav = false
          return
        }
        this.detailTopList = res.data;
        this.dldata = this.detailTopList[0];
        this.getTopData(this.detailTopList[0].parameter,this.detailTopList[0].description)
      })
    },
    changed(index,item){
      this.isdl = index
      this.dldata = item
      this.getTopData(item.parameter,index,item.description)
    },
    getTopData(parameter,index,description){
      if (!Array.isArray(parameter) || !parameter.length) {
        this.loadingCav = false
        return
      }
      let that = this;
      let data = parameter.join(',');
      let param = {};
      param.method="post";
      param.url="/electricQuality/getHarmonicData";
      param.data=qs.stringify({
        monitorSiteId: this.detailSaveId,
        searchDate: this.xbDate,
        startTime: this.xbDate + ' 00:00:00',
        endTime: this.xbDate + ' 23:59:59',
        "params":data.split(",")
      })
      Axios.ajax(param).then((res)=>{
        if (res.resultCode == 0 && res.data && res.data.length > 0) {
          let cavdata = []
          let cavtitle = ''
          cavtitle=res.data[0]
          for(let i=1;i<res.data.length;i++){
            cavdata.push(res.data[i])
          }
          that.drewcav01(cavtitle,cavdata,index,description)
        } else if (res.resultCode != 0) {
          this.$message.warning(res.resultMessage);
        }
        that.loadingCav = false
      })
    },
    getxbhldata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/electricQuality/harmonicContent";
      param.data=qs.stringify({
        monitorSiteId:this.detailSaveId,
        searchDate:this.xbhlDate,
        startTime:this.xbhlDate + ' 00:00:00',
        endTime:this.xbhlDate + ' 23:59:59',
        "params":""
      })
      Axios.ajax(param).then((res)=>{
        if (res.resultCode == 0 && res.data && res.data.length > 0) {
          let cavdata=[]
          let cavtitle=''
          cavtitle=res.data[0]
          for(let i=1;i<res.data.length;i++){
            cavdata.push(res.data[i])
          }
          that.drewcav02(cavtitle, cavdata)
        } else if (res.resultCode != 0) {
          this.$message.warning(res.resultMessage);
        }
        that.loadingCav01 = false
      })
    },
    getdypcdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/electricQuality/voltageDeviation";
      param.data=qs.stringify({
        monitorSiteId:this.detailSaveId,
        searchDate:this.dypcDate,
        startTime:this.dypcDate + ' 00:00:00',
        endTime:this.dypcDate + ' 23:59:59',
        "params":""
      })
      Axios.ajax(param).then((res)=>{
        if (res.resultCode == 0 && res.data && res.data.length > 0) {
          let cavdata=[]
          let cavtitle=[]
          cavtitle=res.data[0]
          for(let i=1;i<res.data.length;i++){
            cavdata.push(res.data[i])
          }
          that.drewcav03(cavtitle, cavdata)
        } else if (res.resultCode != 0) {
          this.$message.warning(res.resultMessage);
        }
        that.loadingCav02 = false
      })
    },
    getplpcdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/electricQuality/harmonicContent";
      param.data=qs.stringify({
        monitorSiteId:this.detailSaveId,
        searchDate:this.plpcDate,
        startTime:this.plpcDate + ' 00:00:00',
        endTime:this.plpcDate + ' 23:59:59',
        "params":""
      })
      Axios.ajax(param).then((res)=>{
        if (res.resultCode == 0 && res.data && res.data.length > 0) {
          let cavdata=[]
          let cavtitle=''
          cavtitle=res.data[0]
          for(let i=1;i<res.data.length;i++){
            cavdata.push(res.data[i])
          }
          that.drewcav04(cavtitle, cavdata)
        } else if (res.resultCode != 0) {
          this.$message.warning(res.resultMessage);
        }
        that.loadingCav03 = false
      })
    },
    drewcav01(title,data,index,description){
      let dom = document.getElementById('leftcav');
      let myChart =this.$echarts.init(dom);
      this.chart=myChart
      this.noDataCav = false
      myChart.clear()
      let xdata=[]
      let series=[]
      let legend=[]
      let colorlist=['rgba(87,128,250,1)','#85f67a','#FFA940','#19AF23','#AAAF23','#00A9ee','#0011ee']
      for(let i=1;i<title.length;i++){
        let color=''
        if(title[i].indexOf('A相') != -1){
          color='rgb(255,165,0)'
        }else if(title[i].indexOf('B相') != -1){
          color='rgb(0,128,0)'
        }else if(title[i].indexOf('C相') != -1){
          color='rgb(255,0,0)'
        }else{
          color=colorlist[i-1]
        }
        series.push({
          name: title[i],
          type: 'line',
          yAxisIndex:0,
          smooth:true,
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0, color: color
              }, {
                offset: 1, color: color
              }]),
              barBorderRadius: 11,
            }
          },
          data: []
        })
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])
        for(let j=1;j<data[i].length;j++){
          series[j-1].data.push(data[i][j])
        }
      }
      let option = {
        tooltip: { trigger: 'axis', confine:true, axisPointer: { type: 'shadow' } },
        legend: { textStyle:{ color:'#666' }, data:legend },
        "dataZoom": [
          { "show": true, "height": 20, filterMode: 'filter', "xAxisIndex": [0], bottom:'10', "start": 0, "end": 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%', handleStyle:{ color:"#d3dee5" }, textStyle:{ color:"#666" }, borderColor:"#d0d5dd" },
          { "type": "inside", "show": true, "height": 20, "start": 1, "end": 35 }],
        grid: { right: '5%', bottom: '24%', left: '5%', top: '20px', containLabel: false },
        xAxis: [{ type: 'category', data: xdata,
          axisLine: { lineStyle: { color: '#e0e3eb' } }, axisTick: { show: false },
          axisLabel: { show: true, color: "#666", fontSize: 12 }
        }],
        yAxis: [
          { type: 'value', nameTextStyle: { color: '#666' },
            axisLine: { show: false },
            splitLine: { show:true, lineStyle: { color: "#edf0f5", type: 'dashed' } },
            axisLabel: { color: '#666', fontSize: 12 } },
          { type: 'value', nameTextStyle: { color: '#666' }, position: 'right',
            axisLine: { show: false },
            splitLine: { show:false },
            axisLabel: { color: '#666', fontSize: 12 } }
        ],
        series: series
      };
      myChart.setOption(option,true);
      // ponytail: 修复 v-show display:none 切换可见时 ECharts canvas 宽度塌陷
      // 容器刚变为可见时 clientWidth 可能仍为 0，canvas 初始化捕获到 0 宽度后不会自动恢复。
      // ResizeObserver 检测到容器真实宽度时再 resize。
      // 升级路径：提取为通用 hook 或复用 se-chart.vue 的 tryInit 模式。
      if (dom.clientWidth === 0) {
        const ro = new ResizeObserver(entries => {
          if (entries[0].contentRect.width > 0) {
            myChart.resize()
            ro.disconnect()
          }
        })
        ro.observe(dom)
      } else {
        myChart.resize()
      }
    },
    drewcav02(title,data){
      let dom = document.getElementById('leftcav01');
      let myChart =this.$echarts.init(dom);
      this.chart01=myChart
      this.noDataCav01 = false
      myChart.clear()
      let xdata=[]
      let series=[]
      let legend=[]
      let colorlist=['rgba(87,128,250,1)','#85f67a','#FFA940','#19AF23','#AAAF23','#00A9ee','#0011ee']
      for(let i=1;i<title.length;i++){
        let color=''
        if(title[i].indexOf('A相') != -1){
          color='rgb(255,165,0)'
        }else if(title[i].indexOf('B相') != -1){
          color='rgb(0,128,0)'
        }else if(title[i].indexOf('C相') != -1){
          color='rgb(255,0,0)'
        }else{
          color=colorlist[i-1]
        }
        series.push({
          name: title[i], type: 'line', yAxisIndex:0, smooth:true,
          itemStyle: { normal: { color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0, color: color
          }, { offset: 1, color: color }]), barBorderRadius: 11 } },
          data: []
        })
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])
        for(let j=1;j<data[i].length;j++){
          series[j-1].data.push(data[i][j])
        }
      }
      let option = {
        tooltip: { trigger: 'axis', confine:true, axisPointer: { type: 'shadow' } },
        legend: { textStyle:{ color:'#666' }, data:legend },
        "dataZoom": [
          { "show": true, "height": 20, filterMode: 'filter', "xAxisIndex": [0], bottom:'10', "start": 0, "end": 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%', handleStyle:{ color:"#d3dee5" }, textStyle:{ color:"#666" }, borderColor:"#d0d5dd" },
          { "type": "inside", "show": true, "height": 20, "start": 1, "end": 35 }],
        grid: { right: '5%', bottom: '24%', left: '5%', top: '20px', containLabel: false },
        xAxis: [{ type: 'category', data: xdata,
          axisLine: { lineStyle: { color: '#e0e3eb' } }, axisTick: { show: false },
          axisLabel: { show: true, color: "#666", fontSize: 12 }
        }],
        yAxis: [
          { type: 'value', nameTextStyle: { color: '#666' },
            axisLine: { show: false },
            splitLine: { show:true, lineStyle: { color: "#edf0f5", type: 'dashed' } },
            axisLabel: { color: '#666', fontSize: 12 } },
          { type: 'value', nameTextStyle: { color: '#666' }, position: 'right',
            axisLine: { show: false },
            splitLine: { show:false },
            axisLabel: { color: '#666', fontSize: 12 } }
        ],
        series: series
      };
      myChart.setOption(option,true);
      myChart.on('click',(param)=>{})
      // ponytail: 同 drewcav01，ResizeObserver 防 v-show display:none 宽度塌陷
      if (dom.clientWidth === 0) {
        const ro = new ResizeObserver(entries => {
          if (entries[0].contentRect.width > 0) {
            myChart.resize()
            ro.disconnect()
          }
        })
        ro.observe(dom)
      } else {
        myChart.resize()
      }
    },
    drewcav03(title,data){
      let dom = document.getElementById('leftcav02');
      let myChart =this.$echarts.init(dom);
      this.chart02=myChart
      this.noDataCav02 = false
      myChart.clear()
      let xdata=[]
      let series=[]
      let legend=[]
      let colorlist=['rgba(87,128,250,1)','#85f67a','#FFA940','#19AF23','#AAAF23','#00A9ee','#0011ee']
      for(let i=1;i<title.length;i++){
        let color=''
        if(title[i].indexOf('A相') != -1){
          color='rgb(255,165,0)'
        }else if(title[i].indexOf('B相') != -1){
          color='rgb(0,128,0)'
        }else if(title[i].indexOf('C相') != -1){
          color='rgb(255,0,0)'
        }else{
          color=colorlist[i-1]
        }
        series.push({
          name: title[i], type: 'line', yAxisIndex:0, smooth:true,
          itemStyle: { normal: { color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0, color: color
          }, { offset: 1, color: color }]), barBorderRadius: 11 } },
          data: []
        })
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])
        for(let j=1;j<data[i].length;j++){
          series[j-1].data.push(data[i][j])
        }
      }
      let option = {
        tooltip: { trigger: 'axis', confine:true, axisPointer: { type: 'shadow' } },
        legend: { textStyle:{ color:'#666' }, data:legend },
        "dataZoom": [
          { "show": true, "height": 20, filterMode: 'filter', "xAxisIndex": [0], bottom:'10', "start": 0, "end": 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%', handleStyle:{ color:"#d3dee5" }, textStyle:{ color:"#666" }, borderColor:"#d0d5dd" },
          { "type": "inside", "show": true, "height": 20, "start": 1, "end": 35 }],
        grid: { right: '5%', bottom: '24%', left: '5%', top: '20px', containLabel: false },
        xAxis: [{ type: 'category', data: xdata,
          axisLine: { lineStyle: { color: '#e0e3eb' } }, axisTick: { show: false },
          axisLabel: { show: true, color: "#666", fontSize: 12 }
        }],
        yAxis: [
          { type: 'value', nameTextStyle: { color: '#666' },
            axisLine: { show: false },
            splitLine: { show:true, lineStyle: { color: "#edf0f5", type: 'dashed' } },
            axisLabel: { color: '#666', fontSize: 12 } },
          { type: 'value', nameTextStyle: { color: '#666' }, position: 'right',
            axisLine: { show: false },
            splitLine: { show:false },
            axisLabel: { color: '#666', fontSize: 12 } }
        ],
        series: series
      };
      myChart.setOption(option,true);
      myChart.on('click',(param)=>{})
      // ponytail: 同 drewcav01，ResizeObserver 防 v-show display:none 宽度塌陷
      if (dom.clientWidth === 0) {
        const ro = new ResizeObserver(entries => {
          if (entries[0].contentRect.width > 0) {
            myChart.resize()
            ro.disconnect()
          }
        })
        ro.observe(dom)
      } else {
        myChart.resize()
      }
    },
    drewcav04(title,data){
      let dom = document.getElementById('leftcav03');
      let myChart =this.$echarts.init(dom);
      this.chart03=myChart
      this.noDataCav03 = false
      myChart.clear()
      let xdata=[]
      let series=[]
      let legend=[]
      let colorlist=['rgba(87,128,250,1)','#85f67a','#FFA940','#19AF23','#AAAF23','#00A9ee','#0011ee']
      for(let i=1;i<title.length;i++){
        let color=''
        if(title[i].indexOf('A相') != -1){
          color='rgb(255,165,0)'
        }else if(title[i].indexOf('B相') != -1){
          color='rgb(0,128,0)'
        }else if(title[i].indexOf('C相') != -1){
          color='rgb(255,0,0)'
        }else{
          color=colorlist[i-1]
        }
        series.push({
          name: title[i], type: 'line', yAxisIndex:0, smooth:true,
          itemStyle: { normal: { color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0, color: color
          }, { offset: 1, color: color }]), barBorderRadius: 11 } },
          data: []
        })
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])
        for(let j=1;j<data[i].length;j++){
          series[j-1].data.push(data[i][j])
        }
      }
      let option = {
        tooltip: { trigger: 'axis', confine:true, axisPointer: { type: 'shadow' } },
        legend: { textStyle:{ color:'#666' }, data:legend },
        "dataZoom": [
          { "show": true, "height": 20, filterMode: 'filter', "xAxisIndex": [0], bottom:'10', "start": 0, "end": 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%', handleStyle:{ color:"#d3dee5" }, textStyle:{ color:"#666" }, borderColor:"#d0d5dd" },
          { "type": "inside", "show": true, "height": 20, "start": 1, "end": 35 }],
        grid: { right: '5%', bottom: '24%', left: '5%', top: '20px', containLabel: false },
        xAxis: [{ type: 'category', data: xdata,
          axisLine: { lineStyle: { color: '#e0e3eb' } }, axisTick: { show: false },
          axisLabel: { show: true, color: "#666", fontSize: 12 }
        }],
        yAxis: [
          { type: 'value', nameTextStyle: { color: '#666' },
            axisLine: { show: false },
            splitLine: { show:true, lineStyle: { color: "#edf0f5", type: 'dashed' } },
            axisLabel: { color: '#666', fontSize: 12 } },
          { type: 'value', nameTextStyle: { color: '#666' }, position: 'right',
            axisLine: { show: false },
            splitLine: { show:false },
            axisLabel: { color: '#666', fontSize: 12 } }
        ],
        series: series
      };
      myChart.setOption(option,true);
      myChart.on('click',(param)=>{})
      // ponytail: 同 drewcav01，ResizeObserver 防 v-show display:none 宽度塌陷
      if (dom.clientWidth === 0) {
        const ro = new ResizeObserver(entries => {
          if (entries[0].contentRect.width > 0) {
            myChart.resize()
            ro.disconnect()
          }
        })
        ro.observe(dom)
      } else {
        myChart.resize()
      }
    },
  },
  watch: {
    riskType(){ this.getTableData() },
    riskValue(){ this.getTableData() },
    xbDate(){ if (this.detailSaveId) this.getTopData(this.dldata.parameter,this.isdl,this.dldata.description) },
    xbhlDate(){ if (this.detailSaveId) this.getxbhldata() },
    dypcDate(){ if (this.detailSaveId) this.getdypcdata() },
    plpcDate(){ if (this.detailSaveId) this.getplpcdata() },
  },
}
</script>

<style lang="scss" scoped>
.quality-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-area {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 12px;
  overflow: hidden;
}

/* 右侧内容卡片 */
.content-card {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 20px;
  transition: margin-left 0.25s ease;

  &.full-width { margin-left: 0; }
}

/* 筛选栏 */
.filter-bar {
  flex-shrink: 0;
  margin-bottom: 12px;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.choose1, .choose2 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sp-search {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 16px;
  height: 32px;
  background: #2A62FF;
  border-radius: 4px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  img{ width: 14px; height: 14px; }
}

/* 卡片列表 */
.eleList {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* 分页 */
.elePage {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
}

/* ===== 详情视图 ===== */
.detail-area {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.detail-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}

.detail-title {
  font-size: 15px;
  font-weight: 600;
  color: #252B3C;
}

.detail-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Harmonic {
  min-height: 380px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
}

.harmonicMore {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.elePower {
  margin-top: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  padding: 12px;
}

.bor-btn {
  padding: 0 14px;
  height: 30px;
  display: flex;
  align-items: center;
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  color: #7D879F;
  font-size: 13px;
  cursor: pointer;
  &:hover { color: #2A62FF; border-color: #2A62FF; }
}

.active-btn {
  color: #2A62FF;
  border-color: #2A62FF;
  background: rgba(42,98,255,0.06);
}

.cav-wrapper {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.cavItem { width: 100%; flex: 1; min-height: 0; }

.cav-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #fff;
  font-size: 14px;
  color: #999;
}

.cav-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: #fff;
}

.cav-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e8ecf1;
  border-top-color: #2A62FF;
  border-radius: 50%;
  animation: cav-spin 0.7s linear infinite;
}

@keyframes cav-spin {
  to { transform: rotate(360deg); }
}

.power { display: flex; flex-direction: column; gap: 12px; }
.powerItem { flex: 1; min-height: 380px; }
</style>
